/**
 * Mobile Team Navigation — locked global nav (top, Team Home).
 * The same segmented control as the league nav, but horizontally scrollable with
 * per-cell min-width, a CLUBHOUSE → FRONT OFFICE group-label divider, a right-edge
 * swipe fade, and a hidden scrollbar. All 14 destinations kept (incl. Optimizer and the
 * deferred Draft / Off Season / Minors entries). Routing + active behavior unchanged.
 */
import React from 'react';
import { navTheme, navIcons } from '../../../services/mobileNavTheme';
import NavCell from './NavCell';

const CLUBHOUSE_ITEMS = [
  { id: 'dashboard', iconKey: 'dashboard', label: 'Dashboard' },
  { id: 'stats', iconKey: 'stats', label: 'Stats' },
  { id: 'roster', iconKey: 'roster', label: 'Roster' },
  { id: 'optimizer', iconKey: 'optimizer', label: 'Optimizer' },
  { id: 'probable-pitchers', iconKey: 'probablePitchers', label: 'Probable' },
  { id: 'box-scores', iconKey: 'boxScores', label: 'Box Scores' },
  { id: 'lineup-history', iconKey: 'lineupHistory', label: 'History' },
  { id: 'team-setup', iconKey: 'teamSetup', label: 'Setup' },
];

const FRONT_OFFICE_ITEMS = [
  { id: 'free-agents', iconKey: 'freeAgents', label: 'Free Agents' },
  { id: 'trade-center', iconKey: 'tradeCenter', label: 'Trades' },
  { id: 'draft', iconKey: 'draft', label: 'Draft' },
  { id: 'off-season', iconKey: 'offSeason', label: 'Off Season' },
  { id: 'watch-list', iconKey: 'watchList', label: 'Watch List' },
  { id: 'minor-league', iconKey: 'minorLeague', label: 'Minors' },
];

const CELL_MIN_WIDTH = '52px';

const MobileTeamNavigation = ({ currentPage, onNavigate }) => {
  const cell = (item, divider) => (
    <NavCell
      key={item.id}
      Icon={navIcons[item.iconKey]}
      label={item.label}
      isActive={currentPage === item.id}
      onClick={() => onNavigate(item.id)}
      cell={navTheme.topCell}
      divider={divider}
      style={{ minWidth: CELL_MIN_WIDTH }}
    />
  );

  return (
    <div style={{
      position: 'sticky',
      top: 0,
      zIndex: 100,
      ...navTheme.topStrip,
      marginBottom: navTheme.clearance, // 4px clearance to the header below
    }}>
      <div
        className="mobile-team-nav-scroll"
        style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        <div style={{ display: 'flex', width: 'max-content', ...navTheme.segment }}>
          {CLUBHOUSE_ITEMS.map((item, i) => cell(item, i > 0))}

          {/* CLUBHOUSE → FRONT OFFICE group-label divider */}
          <div style={{
            minWidth: navTheme.group.minWidth,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 6px',
            borderLeft: navTheme.cellDivider,
            background: navTheme.group.background,
            color: navTheme.group.color,
          }}>
            <span style={{
              fontSize: navTheme.group.labelSize,
              fontWeight: navTheme.group.labelWeight,
              letterSpacing: '.4px',
              lineHeight: 1.15,
              textTransform: 'uppercase',
              textAlign: 'center',
            }}>
              Front<br />Office
            </span>
          </div>

          {FRONT_OFFICE_ITEMS.map((item) => cell(item, true))}
        </div>
      </div>

      {/* Right-edge swipe fade (signals more destinations off-screen) */}
      <span aria-hidden="true" style={{
        position: 'absolute',
        top: '2px',
        bottom: '2px',
        right: '12px',
        width: '22px',
        background: navTheme.scrollFade,
        pointerEvents: 'none',
      }} />

      <style>{`.mobile-team-nav-scroll::-webkit-scrollbar { display: none; }`}</style>
    </div>
  );
};

export default MobileTeamNavigation;
